import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { INVALID_EMAIL, REQUIRED, ACCEPT_TERMS } = ERROR_TYPE;

export const ContactUsSchema = z
	.object({
		privacyPolicy: z.boolean(),
		name: z.string().min(1, { message: REQUIRED }).trim(),
		email: z.string().email(INVALID_EMAIL),
		message: z.string().min(1, { message: REQUIRED }).trim(),
	})
	.superRefine(({ privacyPolicy }, ctx) => {
		if (!privacyPolicy) {
			ctx.addIssue({
				code: "custom",
				path: ["privacyPolicy"],
				message: ACCEPT_TERMS,
			});
		}
	});

export type ContactUsType = z.infer<typeof ContactUsSchema>;
